import { min } from 'lodash'
import cx from 'clsx'
import produce from 'immer'
import { Input } from 'antd'
import { createChildListViewComponent } from 'factories/ChildListView'
import entityNames from 'options/entityNames'
import { isReadOnly } from 'helpers/formViews'
import InputNumber from 'elements/InputNumber'

export default createChildListViewComponent({
  entityName: entityNames.rfqs,
  childName: 'rfqItemSupplierDetails',
  allowCreate: (self) => false,
  allowDelete: (self) => false,
  allowCustomize: (self) => false,
  allowSearching: (self) => false,
  allowSelection: (self) => false,
  allowPagination: (self) => false,
  tableCellComponents: {
    price: (self, item) => (
      <InputNumber
        className={cx({
          'form-field-success':
            !self.props.userIsInRoleSupplier &&
            min(self.props.items.filter((x) => x.price > 0).map((y) => y.price)) === item.price,
        })}
        value={item.price}
        onChange={async (value) => {
          try {
            await self.props.onChange(
              produce(self.props.items, (draft) => {
                if (isFinite(value)) {
                  draft.find((one) => one.id === item.id).price = value
                }
              })
            )
          } catch (error) {
            console.warn(error)
          }
        }}
        min={0}
        readOnly={isReadOnly(self)}
        currency
      />
    ),
    comment: (self, item) => (
      <Input
        value={item.comment}
        onChange={async (e) => {
          try {
            await self.props.onChange(
              produce(self.props.items, (draft) => {
                draft.find((one) => one.id === item.id).comment = e.target.value
              })
            )
          } catch (error) {
            console.warn(error)
          }
        }}
        readOnly={isReadOnly(self)}
      />
    ),
  },
})()
